import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import DevicesTable from 'components/tables/DevicesTable/DevicesTable';
import useGlobalStyles from 'styles/globalStyles';


// The phones the app runs on, to block one - and every account on it.
export default function DevicesPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Devices'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <DevicesTable />
        </Box>
      </Container>
    </Box>
  )
}
